import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a19a0be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header d-flex justify-content-between" }
const _hoisted_2 = { class: "title m-0 pt-1 pt-md-0" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "modal_content" }
const _hoisted_5 = { class: "modal_header pb-3" }
const _hoisted_6 = { class: "pt-2 pb-2" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "footer float-end m-3 mt-0 me-0 me-md-3" }

import BsDialog from '@/components/BsDialog/BsDialog.vue'
import XCircleIcon from '@/icons/XCircleIcon.vue'
import BarButton from '@/components/BarButton'
import { CoachingSessionCancelViewModel } from './CoachingSessionCancel.interfaces'
import locales from './CoachingSessionCancel.locales.en.json'
import CoachingSessionInfoBox from '../CoachingSessionInfoBox/CoachingSessionInfoBox.vue'
import LsatCoachingSessionInfoBox from '../CoachingSessionInfoBox/LsatCoachingSessionInfoBox.vue'
import { useSessionRegistryStore } from '../SessionRegistryStore'


export default /*#__PURE__*/_defineComponent({
  __name: 'CoachingSessionCancel',
  props: {
    modelValue: {}
  },
  emits: ["remove-from-session"],
  setup(__props: any, { emit: __emit }) {

const { sessionState } = useSessionRegistryStore()

const props =
  __props

const emit =
  __emit

async function cancelSession() {
   emit('remove-from-session')
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BsDialog, {
    "class-names": "coaching-session-cancel-dialog",
    "close-on-escape": "",
    "close-on-backdrop-click": ""
  }, {
    header: _withCtx(({ close }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h5", _hoisted_2, _toDisplayString(!_unref(sessionState).isLSAT ? _unref(locales).title_session_cancel : _unref(locales).title_session_cancel_LSAT), 1),
        _createElementVNode("button", {
          class: "button",
          onClick: close
        }, [
          _createVNode(XCircleIcon)
        ], 8, _hoisted_3)
      ])
    ]),
    footer: _withCtx(({ close }) => [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_unref(BarButton), {
          mode: "outline",
          class: "footer-button",
          onClick: close
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(locales).go_back), 1)
          ]),
          _: 2
        }, 1032, ["onClick"]),
        _createVNode(_unref(BarButton), {
          class: "footer-button me-0 me-md-2",
          onClick: cancelSession
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(locales).cancel_session), 1)
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(locales).cancel_confirmation), 1)
        ]),
        (_unref(sessionState).isLSAT)
          ? (_openBlock(), _createBlock(LsatCoachingSessionInfoBox, {
              key: 0,
              "coaching-session": props.modelValue.event,
              "include-description": false
            }, null, 8, ["coaching-session"]))
          : (_openBlock(), _createBlock(CoachingSessionInfoBox, {
              key: 1,
              "coaching-session": props.modelValue.event
            }, null, 8, ["coaching-session"])),
        _createElementVNode("p", {
          class: "fw-bold pt-3 m-0",
          innerHTML: _unref(locales).cancel_reassurance
        }, null, 8, _hoisted_7)
      ])
    ]),
    _: 1
  }))
}
}

})